module.exports = __webpack_public_path__ + "img/87.2.TN.9841fd3f.png";